import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Twitter, Facebook, Youtube, Mail, Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-muro-darker border-t border-muro-gray-800">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="text-2xl font-bold text-gold-gradient">CE</div>
              <div className="flex flex-col leading-tight">
                <span className="text-muro-gold font-bold text-lg tracking-wider">
                  EL MURO
                </span>
                <span className="text-muro-text text-xs tracking-widest">
                  ENDLER
                </span>
              </div>
            </div>
            <p className="text-muro-text-muted text-sm">
              Cómo construir una defensa inquebrantable y conquistar el mundo.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muro-text-muted hover:text-muro-gold transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muro-text-muted hover:text-muro-gold transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muro-text-muted hover:text-muro-gold transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muro-text-muted hover:text-muro-gold transition-colors"
                aria-label="YouTube"
              >
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Enlaces Rápidos */}
          <div>
            <h4 className="text-muro-gold font-semibold mb-4 gold-accent-line">
              Enlaces Rápidos
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-muro-text-muted hover:text-muro-gold transition-colors text-sm"
                >
                  Inicio
                </Link>
              </li>
              <li>
                <Link
                  to="/libro"
                  className="text-muro-text-muted hover:text-muro-gold transition-colors text-sm"
                >
                  El Libro
                </Link>
              </li>
              <li>
                <Link
                  to="/tiane"
                  className="text-muro-text-muted hover:text-muro-gold transition-colors text-sm"
                >
                  Sobre Tiane
                </Link>
              </li>
              <li>
                <Link
                  to="/logros"
                  className="text-muro-text-muted hover:text-muro-gold transition-colors text-sm"
                >
                  Logros
                </Link>
              </li>
            </ul>
          </div>

          {/* El Libro */}
          <div>
            <h4 className="text-muro-gold font-semibold mb-4 gold-accent-line">
              El Libro
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/comprar"
                  className="text-muro-text-muted hover:text-muro-gold transition-colors text-sm"
                >
                  Comprar Ahora
                </Link>
              </li>
              <li>
                <Link
                  to="/libro#capitulos"
                  className="text-muro-text-muted hover:text-muro-gold transition-colors text-sm"
                >
                  Capítulos
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muro-text-muted hover:text-muro-gold transition-colors text-sm"
                >
                  Preventa Especial
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-muro-text-muted hover:text-muro-gold transition-colors text-sm"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h4 className="text-muro-gold font-semibold mb-4 gold-accent-line">
              Mantente Informado
            </h4>
            <p className="text-muro-text-muted text-sm mb-4">
              Recibe noticias sobre el libro y contenido exclusivo de Tiane.
            </p>
            <form className="space-y-2">
              <div className="flex">
                <input
                  type="email"
                  placeholder="Tu email"
                  className="flex-1 px-4 py-2 bg-muro-gray-800 border border-muro-gray-700 rounded-l-md text-muro-text text-sm focus:outline-none focus:border-muro-gold"
                />
                <button
                  type="submit"
                  className="px-4 py-2 bg-muro-gold text-muro-black font-semibold rounded-r-md hover:bg-muro-gold-light transition-colors"
                  aria-label="Suscribirse"
                >
                  <Mail className="w-4 h-4" />
                </button>
              </div>
              <p className="text-xs text-muro-text-dark">
                No spam. Solo contenido valioso.
              </p>
            </form>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-muro-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-muro-text-muted text-sm">
              © {currentYear} El Muro Endler. Todos los derechos reservados.
            </p>
            <div className="flex items-center space-x-1 text-sm text-muro-text-muted">
              <span>Hecho con</span>
              <Heart className="w-4 h-4 text-muro-red fill-current" />
              <span>para todas las niñas valientes</span>
            </div>
            <div className="flex space-x-6 text-sm">
              <a
                href="#"
                className="text-muro-text-muted hover:text-muro-gold transition-colors"
              >
                Privacidad
              </a>
              <a
                href="#"
                className="text-muro-text-muted hover:text-muro-gold transition-colors"
              >
                Términos
              </a>
              <a
                href="#"
                className="text-muro-text-muted hover:text-muro-gold transition-colors"
              >
                Contacto
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
